{
  "fr": {
    "admin": {
      "features": {
        "title": "Fonctionnalités expérimentales",
        "description": "Activer ou désactiver les fonctionnalités expérimentales pour votre compte. Les modifications seront appliquées au prochain chargement de la page.",
        "search": "Rechercher des fonctionnalités...",
        "noResults": "Aucune fonctionnalité trouvée.",
        "activatedForYou": "Déjà activé pour vous",
        "globallyActive": "Activé pour tous",
        "tabsLabel": "Zones de fonctionnalités",
        "tabs": {
          "mine": "Mes fonctionnalités",
          "management": "Gestion des fonctionnalités",
          "permanent": "Fonctionnalités permanentes"
        }
      },
      "featureFlags": {
        "description": "Feature Flags pour tous les utilisateurs – pas seulement pour votre propre compte (contrairement à l'onglet « Mes fonctionnalités »).",
        "permanentDescription": "Flags d'infrastructure permanents (par ex. fournisseurs de connexion OAuth) pour tous les utilisateurs – sans workflow de nettoyage ou date d'activation.",
        "search": "Rechercher des flags...",
        "noResults": "Aucun Feature Flag trouvé.",
        "activatedAt": "Activé le {date}",
        "reviewWarning": {
          "title": "Ces Feature Flags doivent être vérifiés et éventuellement supprimés :",
          "staleActivation": "activé il y a plus d'une semaine"
        },
        "state": {
          "on": "Activé",
          "conditional": "Conditionnel",
          "off": "Désactivé"
        },
        "gatesSummary": {
          "actors": "{count} utilisateur | {count} utilisateurs",
          "groups": "{count} groupe | {count} groupes",
          "percentageOfActors": "{value} % des utilisateurs",
          "percentageOfTime": "{value} % du temps"
        },
        "detail": {
          "title": "Gérer le flag : {name}",
          "booleanSection": "Complètement activé",
          "booleanHint": "Active ou désactive le flag pour tous les utilisateurs.",
          "enabledLabel": "Activé pour tous",
          "actorsSection": "Utilisateurs individuels",
          "actorsHint": "Rechercher et débloquer des utilisateurs.",
          "actorsSearchLabel": "Rechercher un utilisateur",
          "actorsSearchPlaceholder": "Entrer un nom ou un e-mail...",
          "actorUnresolved": "Utilisateur inconnu",
          "removeActor": "Supprimer",
          "groupsSection": "Groupes",
          "percentageOfActorsSection": "Pourcentage des utilisateurs",
          "percentageOfTimeSection": "Pourcentage du temps",
          "percentageSave": "Enregistrer",
          "clearGates": "Réinitialiser tous les déblocages",
          "clearGatesConfirm": "Réinitialiser vraiment toutes les autorisations (utilisateurs, groupes, pourcentages) pour « {name} » ? Cela ne peut pas être annulé.",
          "clearGatesConfirmButton": "Réinitialiser",
          "clearGatesCancel": "Annuler",
          "activationSection": "Historique des activations",
          "activatedBy": "Activé par {name} le {date}",
          "neverActivated": "Jamais complètement activé.",
          "close": "Fermer"
        },
        "toast": {
          "updated": "Feature Flag mis à jour.",
          "error": "Action échouée. Veuillez réessayer."
        }
      }
    }
  }
}
